import React, { FC } from 'react'

import { useUserType } from 'core/hooks'

import ActionDisabledMessage from './ActionDisabledMessage'

type PermissionMessageProps = {
  backUrl: string
}

const PermissionMessage: FC<PermissionMessageProps> = ({ backUrl }) => {
  const userType = useUserType()

  return (
    <ActionDisabledMessage
      message={
        userType === 'agent' ?
          'You do not have the required permissions to perform this action.  Please contact your supervisor for help.'
        : 'You do not have the required permissions to perform this action.  Please contact support for help.'
      }
      backUrl={backUrl || '/loans'}
    />
  )
}

export default PermissionMessage
